import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import axios from 'axios';
// import { authLogout } from '../store/authActions';
import { useNavigate } from 'react-router-dom';
// import { useDispatch } from 'react-redux';

import { AuthLogout } from '../atom/actions';
import { Token } from '../atom/atom'
import { useRecoilValue, useSetRecoilState } from 'recoil';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: '#fff',
    border: '2px solid #000',
    boxShadow: 1,
    p: 4,
    backgroundColor: '#fff',
    padding: '50px'
};

export default function SignOutModal() {
    const navigate = useNavigate()
    const setIsAuthenticated = useSetRecoilState(Token)
    function handleLogout() {
        AuthLogout()
        setIsAuthenticated(null)
        console.log('logged out')
        navigate('/home')
    }

    return (
        <div>

            <Modal
                open={true}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box style={style}>
                    <Typography id="modal-modal-title" variant="h6">
                        Are you sure you want to log out?
                    </Typography>
                    <Button onClick={() => { handleLogout() }}>Log Out</Button>
                    <Button>Cancel</Button>
                </Box>
            </Modal>
        </div>
    );
}